import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/** Espera a que la solapa reanude la cookie, sin mostrar el formulario de login. */
const AuthBootScreen: React.FC = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress />
  </Box>
);

export default AuthBootScreen;
